import { breakpoints, css } from '../../styles/theme';

export const StylesDS = css`
    .left,
    .right {
        visibility: hidden;
    }
    .center {
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }
`;
